<template>
  <a
    href="https://onemotion.co.uk"
    target="_blank"
    title="onedesk - open source no-code database tool and Airtable alternative"
  >
    <Logo
      height="14"
      alt="onedesk - open source no-code database tool and Airtable alternative"
    />
  </a>
</template>

<script>
export default {
  name: 'ExternalLinkonedeskLogo',
}
</script>
